import React from 'react';
import { Avatar } from 'antd';

const getHashOfString = (str) => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return Math.abs(hash);
};

const normalizeHash = (hash, min, max) => {
  return Math.floor((hash % (max - min)) + min);
};

const hRange = [0, 360];
const sRange = [10, 100];
const lRange = [30, 100];

const generateHSL = (name) => {
  const hash = getHashOfString(name);
  const h = normalizeHash(hash, hRange[0], hRange[1]);
  const s = normalizeHash(hash, sRange[0], sRange[1]);
  const l = normalizeHash(hash, lRange[0], lRange[1]);

  return `hsl(${h}, ${s}%, ${l}%)`;
};

const ChatDrawerAvatar = ({ width = '32px', height = '32px', fullName, avatarURL, classes, styles }) => {
  return (
    <Avatar
      src={avatarURL}
      className={`chat-avatar ${classes}`}
      style={{
        backgroundColor: avatarURL ? 'white' : generateHSL(fullName),
        verticalAlign: 'middle',
        width: width,
        height: height,
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
        ...styles,
      }}
      size='default'
    >
      {fullName.length > 0 ? fullName.charAt(0).toUpperCase() : ''}
    </Avatar>
  );
};

export default ChatDrawerAvatar;
